import { QUESTION_OPTIONS } from './question-and-answer-item.constants';
import { QuestionOption } from './question-and-answer-item.types';

export const getQuestionOptions = (roomCode: string, taskNo: number, questionNo: number): QuestionOption[] =>
  QUESTION_OPTIONS[roomCode]?.[`task-${taskNo}`]?.[questionNo] ?? [];

export const isSameAnswer = (a: string, b: string) => a.toLowerCase() === b.toLowerCase();
